// extracted by mini-css-extract-plugin
export default {"title":"ForgotCard_title__pICBL","backLogin":"ForgotCard_backLogin__71DhY","message":"ForgotCard_message__oIEQs"};